import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.checktop');
import { Input, Output, EventEmitter } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-checktop',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.checktop/view.scss */
/* src/app/component.checktop/view.scss: no such file or directory */`],
})
export class ComponentChecktopComponent {
  @Input() activeTab: string = "pending"; // ✅ 기본값
  @Output() tabChange = new EventEmitter<string>();

  constructor(@Inject( Service) public service: Service) {}

  public changeTab(tab: string) {
    this.activeTab = tab;
    this.tabChange.emit(tab); // ✅ 부모(page.check)에 알림
  }
}

export default ComponentChecktopComponent;